module.exports = __webpack_public_path__ + "static/media/inventory.a77ecd89.svg";